import React, { SyntheticEvent, useEffect, useState } from 'react';
import { Nav } from 'react-bootstrap';
import { ReportNavHeaderRow } from './ReportNavHeaderRow';
import { Bookmark, NavigationItemType, Report } from 'core/slices/models';
import { useAppSelector } from 'core/store';
import { ReportNavBookmarkList } from './ReportNavBookmarkList';

interface ReportNavItemProps {
  elem: Report;
  activeBookmarkId?: number;
  isActive?: boolean;
  getReportState?: () => Promise<string>;
  onNavigate?: (reportId: string, bookmarkId?: number) => void;
  onReportClick?: (report: Report) => void;
  onBookmarkClick?: (bookmark: Bookmark) => void;
  onAddBookmarkClick?: () => void;
  onEditBookmarkClick?: (bookmark: Bookmark) => void;
  activeReport?: Report;
}

const ReportNavItem: React.FC<ReportNavItemProps> = ({
  elem,
  activeReport,
  onReportClick,
  onBookmarkClick,
  onAddBookmarkClick,
  onEditBookmarkClick,
}: ReportNavItemProps) => {
  const [isActive, setIsActive] = useState(elem.id === activeReport?.id);
  const [showBookmarks, setShowBookmarks] = useState(false);

  useEffect(() => {
    setIsActive(elem.id === activeReport?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeReport]);

  const activeBookmark = useAppSelector(state => state.reports.activeBookmark);

  const onNavElemClick = () => {
    onReportClick && onReportClick(elem);
  };

  const toggleStateBookMark = (e: SyntheticEvent) => {
    e.stopPropagation();
    setShowBookmarks(!showBookmarks);
  };

  if (elem.nodeType === NavigationItemType.CATEGORY) {
    return <></>;
  }

  const onAddBookmarkClickMenu = () => {
    onAddBookmarkClick && onAddBookmarkClick();
  };

  const onSelectBookMarkClickMenu = (bookmark: Bookmark) => {
    onBookmarkClick && onBookmarkClick(bookmark);
  };

  const onEditBookmarkClickMenu = (bookmark: Bookmark) => {
    onEditBookmarkClick && onEditBookmarkClick(bookmark);
  };

  return (
    <Nav className="flex-column">
      <ReportNavHeaderRow
        elem={elem}
        isActive={isActive}
        onNavElemClick={onNavElemClick}
        toggleStateBookMark={toggleStateBookMark}
      />
      {showBookmarks && (
        <ReportNavBookmarkList
          elem={elem}
          activeBookmark={activeBookmark}
          onAddBookmarkClickMenu={onAddBookmarkClickMenu}
          onSelectBookMarkClickMenu={onSelectBookMarkClickMenu}
          onEditBookmarkClickMenu={onEditBookmarkClickMenu}
        />
      )}
    </Nav>
  );
};

export default ReportNavItem;
